const PathConstants = {
    HOME: "/",
    ALLCRYPTO: "/all-crypto",
    NEWS: "/news",
}

export default PathConstants